import Icon from '../components/Icon.vue'

Icon.register({
  'heart-broken': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M473.7 73.8c48.7 49.8 50.8 129.1 7.3 182.1l-212.2 218.7c-7.1 7.3-18.6 7.3-25.7 0l-212.1-218.6c-43.5-53.1-41.4-132.4 7.3-182.2l2.4-2.4c46.3-47.4 119-51.8 170.7-14l28.6 86.5-96 64 144 144-48-128 96-64-34.3-103.4c51.6-36.9 123.6-32.2 169.6 14.8z'
      }
    ]
  }
})
